module.exports = __webpack_public_path__ + "static/media/6D7DAFC8-042C-41A9-8AB6-28295DA2A614-min.5ed1070f.jpg";